export default __webpack_public_path__ + "static/media/icon4.90a7ffd0.svg";